import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import { useCallback, useMemo } from 'react';
import { THEME } from 'reporting-ui-components/constants/themes';
import { OptionComponent, ValueComponent } from './ColorThemeItem';
import { getDisplayParamsColorTheme } from 'reporting-data/report/configReportGetters';
import { isReportValidForColorThemeDropdown } from './utils';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const OFFERED_THEMES = [THEME.MULTI, THEME.ORANGES, THEME.AQUAS, THEME.PURPLES, THEME.YELLOWS, THEME.PINKS, THEME.BLUES, THEME.GREENS, THEME.PATTERNS];
const ColorThemeDropdown = ({
  onChange,
  report,
  buttonUse = 'transparent'
}) => {
  const currentValue = useMemo(() => {
    const colorTheme = getDisplayParamsColorTheme(report);
    return colorTheme ? colorTheme : 'multi';
  }, [report]);
  const themeOptions = useMemo(() => OFFERED_THEMES.map(theme => ({
    text: I18n.text(`report-customization-components.customization-components.color-theme-dropdown.options.${theme}`),
    value: theme
  })), []);
  const onColorThemeChange = useCallback(({
    target: {
      value
    }
  }) => {
    const updatedReport = report.setIn(['displayParams', 'colors'], ImmutableMap({
      theme: value
    }));
    onChange(updatedReport);
  }, [report, onChange]);
  if (!isReportValidForColorThemeDropdown(report)) {
    return null;
  }
  if (buttonUse === 'transparent') {
    return /*#__PURE__*/_jsx(Select, {
      "data-test-id": "color-theme-dropdown",
      buttonUse: buttonUse,
      menuWidth: "auto",
      onChange: onColorThemeChange,
      options: themeOptions,
      searchable: false,
      defaultValue: THEME.MULTI,
      value: currentValue,
      valueComponent: ValueComponent,
      optionComponent: OptionComponent,
      padding: "0"
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text('report-customization-components.customization-components.color-theme-dropdown.label'),
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "color-theme-dropdown",
      buttonUse: buttonUse,
      menuWidth: "auto",
      onChange: onColorThemeChange,
      options: themeOptions,
      searchable: false,
      defaultValue: THEME.MULTI,
      value: currentValue,
      valueComponent: ValueComponent,
      optionComponent: OptionComponent
    })
  });
};
export default ColorThemeDropdown;